import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchPageContent } from "../api/contentApi";
import { useLang } from "../context/LangContext";
import HeroSection from "./main_hero.jsx";
import main from "../assets/main.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faGears, faUser,faHandshake } from "@fortawesome/free-solid-svg-icons";
import "../styles/main_page.css";

export default function MainPage() {
  const [content, setContent] = useState({});
  const { lang } = useLang();

  const navigate = useNavigate();


  useEffect(() => {
    fetchPageContent("main", lang).then(data => setContent(data));
  }, [lang]);

  if (!content) return <p>Loading...</p>;
  return (
  <section>
    <div className="main-hero-section"><HeroSection/></div>
     {content.main_text_1 && (
        <p className="main-text-subtitle">{content.main_text_1}</p>
      )}

<div className="section-divider"></div>

<div className="intro-row">

  <div className="intro-item">
    <h3>{content.intro_title_1}</h3>
    <p>{content.intro_text_1}</p>
  </div>

  <div className="intro-item">
    <h3>{content.intro_title_2}</h3>
    <p>{content.intro_text_2}</p>
  </div>

  <div className="intro-item">
    <h3>{content.intro_title_3}</h3>
    <p>{content.intro_text_3}</p>
  </div>

</div>

<div className="section-divider"></div>


      <div className="main-texts-container">
        {content.main_text_2 && (
          <div
            className="main-card"
            onClick={() => navigate("/about")}
            role="button"
          >
            <div className="main-card-icon">
             <FontAwesomeIcon icon={faCircleInfo} />
            </div>
            <p className="main-card-title">{content.main_text_2}</p>
            <p className="main-card-description">{content.main_text_2_description}</p>
            <p className="main-card-link">{content.main_text_2_link}</p>
          </div>
        )}

        {content.main_text_3 && (
          <div
            className="main-card"
            onClick={() => navigate("/services")}
            role="button"
          >
            <div className="main-card-icon">
              <FontAwesomeIcon icon={faGears} />
            </div>
            <p className="main-card-title">{content.main_text_3}</p>
            <p className="main-card-description">{content.main_text_3_description}</p>
<p className="main-card-link">{content.main_text_3_link}</p>
          </div>
        )}

        {content.main_text_4 && (
          <div
            className="main-card"
            onClick={() => navigate("/career")}
            role="button"
          >
            <div className="main-card-icon">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <p className="main-card-title">{content.main_text_4}</p>
            <p className="main-card-description">{content.main_text_4_description}</p>
            <p className="main-card-link">{content.main_text_4_link}</p>
          </div>
        )}

        {content.main_text_5 && (
          <div
            className="main-card"
            onClick={() => navigate("/collaboration")}
            role="button"
          >
            <div className="main-card-icon">
              <FontAwesomeIcon icon={faHandshake} />
            </div>
            <p className="main-card-title">{content.main_text_5}</p>
            <p className="main-card-description">{content.main_text_5_description}</p>
             <p className="main-card-link">{content.main_text_5_link}</p>
          </div>
        )}
</div>

        <div className="main-image-container">
            <img
          src={main}
          alt="Ship hull construction"
          className="page-image"
  />

        </div>
        <div className="main-texts-container">
        {content.main_text_6 && (
          <div className="main-card">
            <p>{content.main_text_6}</p>
          </div>
        )}

        {content.main_text_7 && (
          <div className="main-card">
            <p>{content.main_text_7}</p>
          </div>
        )}
      </div>

      <div className="spacer" />
    </section>
  );
}